// Copyright (c) StrangeBee 2024

import React, { ReactElement, useState } from 'react';
import { AttachmentType } from 'thehive-sdk';
import { getFileDatastoreUrl } from '@Helpers/';
import { THImagePreview } from '@Molecules/THImagePreview/THImagePreview';
import { ICONS } from '@Constants/iconsApp';
import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import client from '@Client';

import './TaskLogFile.scss';

interface TaskLogFileProps {
    attachment: AttachmentType;
    taskLogId: string;
}

const TaskLogFile = ({ attachment, taskLogId }: TaskLogFileProps): ReactElement => {
    const { name, id, contentType, _id } = attachment;
    const [showImage, setShowImage] = useState(false);

    return (
        <div className="task-log-file">
            {contentType.startsWith('image') && (
                <div className="task-log-file__link__img__container" onClick={() => setShowImage(true)}>
                    <img
                        src={window.location.origin + client.apiUrl + `/v1/log/${taskLogId}/attachment/${_id}`}
                        className="task-log-file__link__img"
                        role="none"
                    />
                </div>
            )}

            <ExternalLink
                className="task-log-file__link"
                url={window.location.origin + client.apiUrl + `/v1/log/${taskLogId}/attachment/${_id}/download`}
            >
                <ICONS.PaperClipOutlined className="task-log-file-link__icon" />
                {name}
            </ExternalLink>

            {showImage && (
                <THImagePreview
                    src={window.location.origin + getFileDatastoreUrl(id)}
                    onClick={() => setShowImage(false)}
                />
            )}
        </div>
    );
};

export default TaskLogFile;
